// @flow
import React, { Component } from 'react'
import _ from 'lodash'
import { translateFunc, translations } from '../../../shared/localize'
import styled, { type StyledComponent } from 'styled-components'
import FieldSet from '../../FieldSet'

const Wrapper: StyledComponent<Object, any, any> = styled.div`
  margin-top: 10px;
`

const Header: StyledComponent<Object, any, any> = styled.div`
  margin-left: ${({ shiftLefter }: Object) => (shiftLefter ? '-10px' : '0')};
  margin-bottom: 5px;
  font-weight: bold;
  font-size: 14px;
`

type Props = {|
  collection: Array<Object>,
  onSelectChange: Function,
  searched: boolean
|}

const t = translateFunc(translations.interests)

export default class FbAdInterests extends Component<Props> {
  renderHeader() {
    const { searched } = this.props
    const title = searched ? t('additional_interests_found') : t('additional_interests')
    return <Header shiftLefter={!searched}>{title}</Header>
  }

  render() {
    const { collection, onSelectChange } = this.props

    if (collection.length === 0) return null

    return (
      <Wrapper>
        {this.renderHeader()}
        <div>
          {_.sortBy(collection, 'label').map((node) => (
            <FieldSet.MatchedNode key={node.id} node={node} onSelectChange={onSelectChange} />
          ))}
        </div>
      </Wrapper>
    )
  }
}
